<div
  class="mcm-loader"
  [class.mcm-loader--loading]="loading()"
  [class.mcm-loader--no-height]="noHeight()">
  <ng-content />

  <div class="mcm-loader__spinner">
    @if (loading()) {
      <ion-spinner [color]="isWhiteSpinnerColor() ? 'light' : ''" />
    }
  </div>
</div>
